var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMaterialVideoCall = function SvgIconMaterialVideoCall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.196,
    height: 10.131,
    viewBox: "0 0 15.196 10.131",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-video-call",
    "data-name": "Icon material-video-call",
    d: "M16.319,12.8V9.844A.847.847,0,0,0,15.475,9H5.344a.847.847,0,0,0-.844.844v8.442a.847.847,0,0,0,.844.844H15.475a.847.847,0,0,0,.844-.844V15.332L19.7,18.709V9.422ZM13.787,14.91H11.254v2.533H9.565V14.91H7.033V13.221H9.565V10.688h1.688v2.533h2.533Z",
    transform: "translate(-4.5 -9)",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMaterialVideoCall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon-material-video-call.fc770d724951b33dce9a94f3ecef13d7.svg";